import { render, staticRenderFns } from "./PaymentMethodPopup.vue?vue&type=template&id=2bcc9270"
import script from "./PaymentMethodPopup.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodPopup.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports